var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 chart-wrapper"},[_c('fusioncharts',{attrs:{"type":"multiaxisline","width":"100%","height":_vm.height,"dataFormat":"json","dataSource":_vm.dataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }